module.exports = __webpack_public_path__ + "img/voucher3.aa40d962.png";